import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { EventBusService } from '@app-shared/services/event-bus.service';
import { UtilService } from '@app-shared/services/util.service';
import { AccountService } from '@app/account/account.service';
import { AdminService } from '@app/admin/admin.service';
import { AppNotificationsService } from '@app/shared/services/app-notifications.service';
import { GetService } from '@app/shared/table/get.service';
import { GetAllService } from '@app/shared/table/getAll.service';
import { SocketService } from '@app/socket.service';
import { get, has } from 'lodash';
import { Subscription, BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { RequestCancellationService } from '@app/shared/services/request-cancellation.service';
import { TourService } from '@app/services/tour.service';



const USER_ROLE_LIST: any = {
  SA: 'Super Admin',
  OA: 'Organization Admin',
  OU: 'Organization User',
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  protected SUPER_ADMIN = 'Super Admin';
  username: any;
  useremail: string;
  menus: any[];
  title: string = 'Dashboard';
  nameTitle: string = '';
  nameTitleValue: string = '';
  hideHeader: boolean = false;
  dividerNotRequired: boolean = true;
  isAutoMenuON: boolean = false;
  isAdmin: boolean = false;
  protected sysAccess: any;
  userOrgList: any = [];
  selectedUserOrg: any;
  loginUserRole: string = '';
  isOrgAdmin: boolean = false;
  eventBusSub?: Subscription;
  showHelpDesk: boolean = false;
  showSettings: boolean = false;
  notificationCount = 0;
  developerUrl: any;
  searchInput: string = '';
  show = false;
  certiplateAdminVer = `v3.${environment.version}`;
  @Output() toggleSideBarForMe: EventEmitter<any> = new EventEmitter();
  @ViewChild('headerMenuList', { static: false, read: ElementRef })
  headerMenuList!: ElementRef<HTMLDivElement>;
  @ViewChild('headerMenuItems') headerMenuItems: ElementRef;
  listOfVisibleMenus: any[];
  listOfNonVisibleMenus: any[];
  courseFrameworkList = [];
  protected orgID: any;
  orgLogo: string;
  isOrgSuperAdmin: boolean;
  isOpen = false;
  subscribedFeatures: any;
  iam_access: boolean = false;
  notification_access: boolean = false;
  userAdministration: boolean = false;

  isExpanded = false;
  private _isExpanded = new BehaviorSubject<boolean>(true);
  isExpanded$ = this._isExpanded.asObservable();

  get isSystemSuperAdmin(): boolean {
    const ur = this.util ? this.util.decrypt(localStorage.getItem('ur')) : '';
    const useremail = localStorage.getItem('useremail') || '';
    const role = localStorage.getItem('role') || '';

    // Strictly check System Super Admin (ur === 'SA') or Root Admin email/role
    return ur === 'SA' || useremail === 'admin@navriti.com' || role.toLowerCase() === 'super admin';
  }

  constructor(
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private accSrvc: AccountService,
    private util: UtilService,
    private eventBusService: EventBusService,
    private getService: GetService,
    private getAllService: GetAllService,
    private notificationsService: AppNotificationsService,
    private socketService: SocketService,
    private adminSrvc: AdminService,
    private requestCancellationService: RequestCancellationService,
    private tourService: TourService
  ) { }

  /** POC: Start the guided dashboard tour via Driver.js */
  startTour(): void {
    this.tourService.startDashboardTour();
  }
  handleLogoClick() {
    this.route.navigate(['/'], {
      replaceUrl: true
    }).then(success => {
      if (!success) {
        window.location.href = '/';
      }
    }).catch(error => {
      window.location.href = '/';
    });
  }
  isLoginPage: boolean = false;

  ngOnInit(): void {
    this.notificationCount = 0;
    this.buildPageTitle();
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.isLoginPage = event.url.includes('/account/login') ||
        event.url.includes('/account/forgot-password') ||
        event.url.includes('/account/reset-password');
      this.changeDetectorRef.markForCheck();
    });
    this.username = localStorage.getItem('username');
    this.useremail = localStorage.getItem('useremail');
    this.selectedUserOrg = this.accSrvc.getUserOrgId();
    this.sysAccess = JSON.parse(
      this.util.decrypt(localStorage.getItem('sys_access'))
    );
    this.menus = JSON.parse(
      this.util.decrypt(localStorage.getItem('menu_access'))
    );

    const OPERATIONS_MENU_ORDER = {
      'assessments': 1,
      'candidates': 2,
      'project': 3,
      'report': 4
    };

    // Filter out Assets from Resources and duplicate Evaluate from Operations
    this.menus = this.menus.map((menu: any) => {
      if (menu.menu_name.toLowerCase() === 'resources') {
        return {
          ...menu,
          pages: menu.pages.filter((page: any) => page.menu_name.toLowerCase() !== 'assets')
        };
      }
      if (menu.menu_name.toLowerCase() === 'operations') {
        return {
          ...menu,
          // Sort the operations menu items
          pages: menu.pages
            .sort((a, b) => {
              const orderA = OPERATIONS_MENU_ORDER[a.menu_name.toLowerCase()] || 999;
              const orderB = OPERATIONS_MENU_ORDER[b.menu_name.toLowerCase()] || 999;
              return orderA - orderB;
            })
            .map((page: any) => {
              // Update 'Project' to 'Projects'
              if (page.menu_name.toLowerCase() === 'project') {
                return {
                  ...page,
                  menu_name: 'Projects'
                };
              }
              if (page.menu_name.toLowerCase() === 'assessments') {
                const getMenuWeight = (menuName: string): number => {
                  const name = menuName.toLowerCase();
                  switch (name) {
                    case 'plan': return 1;
                    case 'conduct viva': return 2;
                    case 'invigilate': return 3;
                    case 'monitor': return 4;
                    case 'evaluate': return 5;
                    default: return 999;
                  }
                };

                // Find all evaluate items and keep only the last one
                const evaluateItems = page.pages.filter(item =>
                  item.menu_name.toLowerCase() === 'evaluate'
                );
                const lastEvaluate = evaluateItems[evaluateItems.length - 1];

                return {
                  ...page,
                  pages: page.pages
                    .filter(subPage => {
                      if (subPage.menu_name.toLowerCase() === 'execute') return false;
                      if (subPage.menu_name.toLowerCase() === 'evaluate') {
                        return subPage === lastEvaluate;
                      }
                      return true;
                    })
                    .sort((a, b) =>
                      getMenuWeight(a.menu_name.toLowerCase()) - getMenuWeight(b.menu_name.toLowerCase())
                    )
                    .map((subPage: any) => ({
                      ...subPage,
                      icon: this.getMenuIcon(subPage.menu_name)
                    }))
                };
              }
              return page;
            })
        };
      }
      return menu;
    });

    this.orgID = this.util.decrypt(localStorage.getItem('OrgId'));
    console.log('Decrypted orgID:', this.orgID);

    this.isAutoMenuON = localStorage.getItem('isautopopulate') === 'on';
    console.log('Is Auto Menu ON:', this.isAutoMenuON);

    const ur = this.util.decrypt(localStorage.getItem('ur'));
    console.log('Decrypted UR:', ur);

    this.isOrgSuperAdmin = JSON.parse(localStorage.getItem('isOrgSuperAdmin'));
    console.log('Is Org Super Admin:', this.isOrgSuperAdmin);

    this.isAdmin = ur === 'SA';
    console.log('Is Admin (SA):', this.isAdmin);

    this.userOrgList = JSON.parse(localStorage.getItem('userOrgList'));
    console.log('User Org List:', this.userOrgList);

    const rawRole = (localStorage.getItem('role') || '').trim();
    console.log('Login User Role (before normalization):', rawRole);

    if (rawRole.toLowerCase() === 'full access') {
      this.loginUserRole = 'Super Admin';
      console.log('Login User Role normalized to:', this.loginUserRole);
    } else if (rawRole.toLowerCase() === 'default access') {
      this.loginUserRole = 'Organization Admin';
      console.log('Login User Role normalized to:', this.loginUserRole);
    } else {
      this.loginUserRole = rawRole;
    }

    const superUserId = localStorage.getItem('superUserId');
    console.log('Super User ID from localStorage:', superUserId);

    if (superUserId && parseInt(superUserId, 10) > 1) {
      this.isOrgAdmin = true;
      console.log('Is Org Admin:', this.isOrgAdmin);
    }
    this.eventBusSub = this.eventBusService.on('logout', () => {
      console.log('Logout event received. Clearing localStorage and navigating to root.');
      this.util.clearStoragePreservingTableColumnPreferences();
      this.route.navigate(['/']);
    });

    console.log(this.notificationCount, 'Notification Count at initialization');

    this.socketService.onNewNotification().subscribe((data: any) => {
      console.log('New Notification Received:', data);
      if(data.title === 'Data Sync')
      this.util.simpleDialog({
        title: 'Success',
        message: data.message
      })

      if (!this.isCommentMentionNotification(data)) {
        this.util.openNotificationDialog(
          data.title,
          data.message,
          'toast-custom'
        );
      }
      this.notificationCount++;
      console.log('Updated Notification Count:', this.notificationCount);
      this.changeDetectorRef.markForCheck();
      this.changeDetectorRef.detectChanges();
    });

    this.developerUrl = `${this.util.getApiUrl()}/docs/?token=${this.accSrvc.jwt}`;
    console.log('Developer URL:', this.developerUrl);

    const cachedLogo = localStorage.getItem('orgLogo');
    if (cachedLogo) {
      this.orgLogo = cachedLogo;
    }

    if (!this.isAdmin) {
      if (!cachedLogo) {
        this.fetchOrgDetails();
      } else {
        setTimeout(() => {
          this.fetchOrgDetails();
        }, 2000);
      }
    }


    // Add this after the menus assignment
    this.menus = this.menus.map((menu: any) => {
      // Remove UserSettings from main menu and add to settings
      if (menu.menu_name === 'UserSettings') {
        // Store user settings items for settings dropdown
        const userSettingsItems = menu.pages.filter((page: any) =>
          // Filter out Assets, Report, and Support submenus
          page.menu_name.toLowerCase() !== 'assets' &&
          page.menu_name.toLowerCase() !== 'report' &&
          page.menu_name.toLowerCase() !== 'support'
        ).map((page: any) => {
          // Explicitly set icon for Report in UserSettings
          const icon = page.menu_name.toLowerCase() === 'report'
            ? 'file-text'
            : this.getMenuIcon(page.menu_name);
          return {
            ...page,
            icon: icon
          };
        });
        // Store for settings dropdown
        localStorage.setItem('userSettingsItems', JSON.stringify(userSettingsItems));
        return null;
      }
      return menu;
    }).filter(Boolean);

    const getDecrypted = (key: string) => {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      try {
        return JSON.parse(this.util.decrypt(raw));
      } catch (error) {
        console.error(`Error parsing ${key}:`, error);
        return null;
      }
    };

    this.subscribedFeatures = getDecrypted('subscribedFeatures');
    this.iam_access = this.subscribedFeatures?.features?.iam;
    this.notification_access = this.subscribedFeatures?.features?.notifications
    this.userAdministration = this.subscribedFeatures?.features?.userCandidateAdmin;
  }

  private isCommentMentionNotification(data: any): boolean {
    const title = String(data?.title || '').toLowerCase();
    const actionType = String(data?.action_type || '').toLowerCase();

    return title.includes('mention') || actionType === 'mentioned';
  }

  ngAfterViewInit() {
    if (this.headerMenuList?.nativeElement) {
      const elementContainsListOfMenus = this.headerMenuList.nativeElement;
      // Calls when the element size changes
      const resizeObserver = new ResizeObserver(() => {
        this.showMenuItemsBasedOnParentWidth();
        // Force Angular to detect changes and update the view immediately
        this.changeDetectorRef.detectChanges();
      });
      resizeObserver.observe(elementContainsListOfMenus);
      this.showMenuItemsBasedOnParentWidth();
      this.changeDetectorRef.markForCheck();
      this.changeDetectorRef.detectChanges();
    }
  }

  showMenuItemsBasedOnParentWidth() {
    if (!this.headerMenuList?.nativeElement) return;
    let numberOfMenusShouldVisible: number;
    const width = this.headerMenuList.nativeElement.clientWidth;

    if (width <= 220) {
      numberOfMenusShouldVisible = 0;
    } else if (width > 220 && width <= 305) {
      numberOfMenusShouldVisible = 1;
    } else if (width > 305 && width <= 430) {
      numberOfMenusShouldVisible = 2;
    } else if (width > 430 && width <= 560) {
      numberOfMenusShouldVisible = 3;
    } else if (width > 560 && width <= 710) {
      numberOfMenusShouldVisible = 4;
    } else if (width > 710 && width <= 820) {
      numberOfMenusShouldVisible = 5;
    } else {
      numberOfMenusShouldVisible = 6;
    }

    this.listOfVisibleMenus = this.menus.slice(0, numberOfMenusShouldVisible);
    this.listOfNonVisibleMenus = this.menus.slice(numberOfMenusShouldVisible);
  }

  /**
   * Generating Headers Dynamically based on the Data Property / Router Params
   */
  buildPageTitle() {
    this.route.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .subscribe((event) => {
        if (!!event.data && has(event.data, '_value.title')) {
          this.title = get(event.data, '_value.title', '') as string;
        } else {
          this.title = get(event, 'routeConfig.path');
        }
        if (!!event.data) {
          this.dividerNotRequired = get(
            event.data,
            '_value.dividerNotRequired',
            true
          );
          this.nameTitle = get(event.data, '_value.nameTitle', '');
          this.nameTitleValue = get(event.params, 'value.name', '');
          this.hideHeader = get(event.data, '_value.hideHeader', false);
        }
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.eventBusSub) {
      this.eventBusSub.unsubscribe();
    }
  }

  logout() {
    this.requestCancellationService.cancelAllPendingRequests();
    this.accSrvc.logout().subscribe({
      next: () => {
        this.util.clearStoragePreservingTableColumnPreferences();
        this.route.navigate(['/account/login']);
      },
      error: () => {
        this.util.clearStoragePreservingTableColumnPreferences();
        this.route.navigate(['/account/login']);
      },
    });
  }

  private closeDropdownListener: any;
  private closeDropdownProfileListener: any;

  ShowDropdown(event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevent event bubbling
    }

    const dropdown = document.getElementById('dropdown');
    if (dropdown) {
      dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';

      // Remove any existing click listener to avoid multiple bindings
      document.body.removeEventListener('click', this.closeDropdownListener);

      // Add a click listener to close the dropdown when clicking outside
      this.closeDropdownListener = (event: any) => {
        if (!dropdown.contains(event.target) &&
          !event.target.closest('.header-icons-container')) {
          dropdown.style.display = 'none';
          document.body.removeEventListener('click', this.closeDropdownListener);
        }
      };

      document.body.addEventListener('click', this.closeDropdownListener);
    }
  }


  handleOrgChange(e: any) {
    e.stopPropagation(); // Prevent the click from reaching the container
    const orgId = e.target.value;
    const selectedOrg = this.userOrgList.filter(
      (org: any) => org.org_id === parseInt(orgId, 10)
    );

    if (selectedOrg && selectedOrg.length) {
      const payload = {
        userId: parseInt(selectedOrg[0].user_id, 10),
        orgId: parseInt(selectedOrg[0].org_id, 10),
      };

      // Store current route before changing org
      const currentRoute = this.route.url;

      this.loginWithOrg(payload, currentRoute); // Pass current route to loginWithOrg
      console.log("changed org in header"  , payload);
      this.accSrvc.getSubscribedFeatures(payload).subscribe(
        (data: any) => {
          const subscribedFeatures = data.body.responseBody;
          localStorage.removeItem('subscribedFeatures');
          localStorage.removeItem('subscribedFeats');
          localStorage.setItem('subscribedFeatures', this.util.encrypt(JSON.stringify(subscribedFeatures)));
          localStorage.setItem('subscribedFeats' , JSON.stringify(subscribedFeatures));
        },
        (err: any) => {
          this.util.errorNotification(err);
        }
      );
         this.accSrvc.isSystemSuperAdmin({ userId: payload.userId }).subscribe(
          (data: any) => {
            try {
              const flag = data.body && data.body.responseBody && data.body.responseBody.is_system_super_admin;
              localStorage.setItem('isSystemSuperAdmin', JSON.stringify(Boolean(flag)));
            } catch (e) {
              localStorage.setItem('isSystemSuperAdmin', 'false');
            }
          },
          (err: any) => {
            // On error, default to false
            localStorage.setItem('isSystemSuperAdmin', 'false');
          }
        );
    }
  }

  loginWithOrg(data: any, currentRoute?: string) {
    const postData = {
      ...data,
    };
    let resp = this.accSrvc.loginWithOrg(postData);
    resp.subscribe(
      (data: any) => {
        const response = data.body.responseBody;
        // Update all local storage items (existing code)
        localStorage.setItem('JwtToken', response.jwtToken);
        localStorage.setItem('refreshToken', response.refreshToken);
        this.util.setTokenExpiryPopup(response.jwtToken, response.refreshToken);
        localStorage.setItem(
          'sys_access',
          this.util.encrypt(JSON.stringify(response.perm))
        );

        if (response.course_framework_id) {
          const postData = {
            courseFrameworkIds: response.course_framework_id,
          };
          this.getService.get('courseFrameworkLabels', postData).subscribe(
            (data: any) => {
              const frameworkLabelsresponse = data.body.responseBody;
              localStorage.setItem(
                'course_framework_labels',
                this.util.encrypt(JSON.stringify(frameworkLabelsresponse))
              );
            },
            (err: any) => {
              this.util.errorNotification(err);
              this.changeDetectorRef.markForCheck();
            }
          );
        }

        if (response.super_user_id) {
          localStorage.setItem('superUserId', response.super_user_id);
        }

        localStorage.setItem('UserId', response.user_id);
        const role = (response.role || '').toLowerCase() === 'default access' ? 'Organization Admin' : response.role;
        localStorage.setItem('role', role);
        localStorage.setItem(
          'OrgId',
          this.util.encrypt(`${response.organization_id}`)
        );
        localStorage.setItem('username', response.full_name);
        localStorage.setItem('useremail', response.username);
        localStorage.setItem('isautopopulate', 'on');
        localStorage.setItem('isOrgSuperAdmin', response.spoc_is_org_admin);

        if (response.spoc_email) {
          const userRole = response.organization_id === -1 ? 'SA' : 'OA';
          localStorage.setItem('ur', this.util.encrypt(userRole));
        } else {
          localStorage.setItem('ur', this.util.encrypt('OU'));
        }
        this.accSrvc.getMenus().subscribe(
          (data: any) => {
            const response = data.body;
            if (response.responseHead.statusCode === '0000') {
              const encriptedResponse = this.util.encrypt(
                JSON.stringify(response.responseBody)
              );
              localStorage.setItem('menu_access', encriptedResponse);

              // NEW: Check if we need to refresh just admin route
              if (currentRoute && currentRoute.includes('/admin')) {
                // Force refresh of admin component
                this.route.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
                  this.route.navigate(['/admin']);
                });
              } else {
                // Existing behavior - full page reload
                window.location.reload();
              }
            }
          },
          (err: any) => {
            console.error(err);
          }
        );

        // Update component state (existing code)
        const ur = this.util.decrypt(localStorage.getItem('ur'));
        const isOrgSuperAdmin = JSON.parse(
          localStorage.getItem('isOrgSuperAdmin')
        );
        this.isAdmin = ur === 'SA' || isOrgSuperAdmin;
        const currentRole = (localStorage.getItem('role') || '').trim();
        if (currentRole.toLowerCase() === 'full access') {
          this.loginUserRole = 'Super Admin';
        } else if (currentRole.toLowerCase() === 'default access') {
          this.loginUserRole = 'Organization Admin';
        } else {
          this.loginUserRole = currentRole;
        }

        const superUserId = localStorage.getItem('superUserId');
        if (superUserId && parseInt(superUserId, 10) > 1) {
          this.isOrgAdmin = true;
        }
      },
      (err: any) => {
        this.util.errorNotification(err);
        this.changeDetectorRef.markForCheck();
      }
    );
  }

  navigateTo(url: any) {
    this.route.navigate(url);
  }
  navigatetoTicket() {
    this.route.navigate(["/ticket"]);
  }


  ShowHelpDeskDropdown() {
    this.showHelpDesk = !this.showHelpDesk;
  }

  showSettingsDropdown() {
    this.showSettings = !this.showSettings;
  }

  clickOutside() {
    this.showHelpDesk = false;
  }

  // Add this method
  toggleSidebar() {
    this.isExpanded = !this.isExpanded;
    this.toggleSideBarForMe.emit(this.isExpanded);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  printInitial(): string {
    const [first, last] = (this.username || '').split(' ');
    return `${first.charAt(0).toUpperCase()}${last ? last.charAt(0).toUpperCase() : ''
      }`;
  }

  get showProgress(): boolean {
    return this.util.showLoader;
  }

  getMenuLabelName(menu: any) {
    // Rename 'Report' to 'Reports'
    if (menu.menu_name.toLowerCase() === 'report') {
      return 'Reports';
    }
    // Conditional rendering of Course module label w.r.t single or multiple Course Frameworks
    if (menu.menu_name === 'Course Groups' && this.courseFrameworkList.length === 1) {
      return `${this.util.getCourseHeadingName(this.courseFrameworkList[0]?.course_framework_id)} Groups`;
    }
    if (menu.menu_name === 'Course SubGroups' && this.courseFrameworkList.length === 1) {
      return `${this.util.getCourseHeadingName(this.courseFrameworkList[0]?.course_framework_id)} SubGroups`;
    }
    //Condition for course framework based rendering of sub-menus
    if (menu.menu_name === 'Courses' && this.courseFrameworkList.length === 1) {
      return this.util.getCourseHeadingName(this.courseFrameworkList[0]?.course_framework_id);
    }
    return menu.menu_name;
  }

  //Function to get all the course framworks by organization id
  getCourseFrameworkList(): void {
    this.getAllService.getAll('courseFrameworksByOrgId').subscribe((data: any) => {
      this.courseFrameworkList = data.body.responseBody;
      this.changeDetectorRef.markForCheck();
    }, (err: any) => {
      this.util.errorNotification(err);
      this.changeDetectorRef.markForCheck();
    });
  }

  fetchOrgDetails(): void {
    if (!this.orgID) return;
    this.adminSrvc
      .getOrgDetails(parseInt(this.orgID))
      .subscribe((data: any) => {
        const response = data.body.responseBody;
        if (response && response.logo_file_name !== this.orgLogo) {
          this.orgLogo = response.logo_file_name;
          localStorage.setItem('orgLogo', this.orgLogo);
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  open(): void {
    if (this.isOpen) {
      this.notificationsService.open();
    } else {
      this.notificationsService.close();
    }
  }

  lookup() {
    this.show = !this.show;
  }

  // Add this helper method to the class
  private getMenuIcon(menuName: string): string {
    // Convert menu name to lowercase for case-insensitive comparison
    const menu = menuName.toLowerCase();

    // Map of menu names to their icons
    const icons: { [key: string]: string } = {
      'plan': 'calendar',
      'conduct viva': 'video',
      'invigilate': 'eye',
      'monitor': 'chart-line',
      'evaluate': 'check-square',
      'roles': 'users',
      'user category': 'user-check',
      'users': 'user'
    };

    return icons[menu] || '';
  }

  // Add this method to retrieve user settings items
  getUserSettingsItems() {
    const items = localStorage.getItem('userSettingsItems');
    if (!items) return [];
    try {
      const parsed = JSON.parse(items);
      return Array.isArray(parsed) ? parsed.filter((item: any) => (item?.menu_name || '').toLowerCase() !== 'support') : [];
    } catch {
      return [];
    }
  }
}
